import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//按配件和客户查询销售情况
class partDealService {
    /*****************************************************************************/

    //分页查询销售单信息
    static async findPage(data) {
        const apiUrl = "/statistics/salesSaleByCustomerAndMaterial";
        return await http.post(apiUrl, data);
    }

    //导出
    static async export(data) {
        const apiUrl = `/statistics/salesSaleByCustomerAndMaterial/export`;
        return await download(apiUrl, {type: "POST", data},600);
    }


    /*****************************************************************************/
}

export default partDealService;